import {
  useQueryStates,
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringEnum,
  createParser,
} from 'nuqs'
import { TimePeriod } from 'api/pulse'
import { addMonths, format, isValid, parse } from 'date-fns'

const parseAsLocalDate = createParser<Date>({
  parse(queryValue: string) {
    const parsedDate = parse(queryValue, 'yyyy-MM-dd', new Date())
    if (!isValid(parsedDate)) {
      return null
    }
    return parsedDate
  },
  serialize(value: Date) {
    return format(value, 'yyyy-MM-dd')
  },
  eq(a: Date, b: Date) {
    return a.getTime() === b.getTime()
  },
})

const timePeriodParser = parseAsStringEnum<TimePeriod>(
  Object.values(TimePeriod)
)

export function usePulseFilterQueryState(defaultCompanyIds: number[]) {
  const defaultDateFrom = addMonths(new Date(), -12) // 12 months ago
  const defaultDateTo = new Date() // today

  const queryStates = useQueryStates(
    {
      companyIds: parseAsArrayOf(parseAsInteger).withDefault(defaultCompanyIds),
      positionTypes: parseAsArrayOf(parseAsString).withDefault([]),
      dateFrom: parseAsLocalDate.withDefault(defaultDateFrom),
      dateTo: parseAsLocalDate.withDefault(defaultDateTo),
      timePeriod: timePeriodParser.withDefault(TimePeriod.Monthly),
    },
    {
      urlKeys: {
        companyIds: 'company-ids',
        positionTypes: 'position-types',
        dateFrom: 'date-from',
        dateTo: 'date-to',
        timePeriod: 'time-period',
      },
    }
  )

  return queryStates
}
